import { GraphQLClient } from "graphql-request";

function resolveApiBase(): string {
  // Explicit env var takes precedence (local dev, CI, etc.)
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl) return envUrl.replace(/\/graphql$/, "");

  const { hostname } = window.location;

  if (hostname === "chamfer.io" || hostname === "www.chamfer.io") return "https://api.chamfer.io";

  // Cloudflare Pages previews → production API
  if (hostname.endsWith(".chamfer.pages.dev") || hostname === "chamfer.pages.dev")
    return "https://api.chamfer.io";

  // Local dev
  if (hostname === "localhost" || hostname === "127.0.0.1") return "http://localhost:4000";

  // Fallback: same-origin (e.g. Railway PR apps behind Caddy proxy)
  return window.location.origin;
}

/** Base URL for REST API calls (e.g. https://api.chamfer.io or same-origin) */
export const API_BASE = resolveApiBase();

const API_URL = `${API_BASE}/graphql`;

export const graphqlClient = new GraphQLClient(API_URL, {
  credentials: "include",
});
